module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    attrs: {
      "id": "notifications-dropdown"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle count-info",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), (_vm.count) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm.count))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-alerts"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('li', {
      class: {
        unread: notification.date.isAfter(_vm.readAt)
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'map',
          query: {
            driver: notification.id
          }
        },
        "title": ""
      }
    }, [_c('span', {
      staticClass: "driver"
    }, [_vm._v(_vm._s(notification.name)), _c('span', {
      staticClass: "rego"
    }, [_vm._v(_vm._s(notification.registration))])]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(notification.location))]), _vm._v(" "), _c('span', {
      staticClass: "datetime"
    }, [_vm._v(_vm._s(notification.date.format('DD/MM/YYYY h:mmA')))])])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-52b2e7d4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 1001
// module chunks = 0